import { createUseStyles } from 'react-jss'

import config from 'styles/config'

import { textSize, boldFont } from '@portal/kit/pkg/styles'

const { boxMobileMargin } = config.dimensions

const ranRoomCardStyles = createUseStyles(theme => ({
  separator: {
    margin: `${boxMobileMargin}px 0`,
    borderBottom: `1px solid ${config.colors.boxSeparator}`,
    width: '100%'
  },
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  text: {
    ...textSize(14, 19),
    flexGrow: 1
  },
  textError: {
    color: config.colors.textError,
    ...boldFont()
  }
}))

export default ranRoomCardStyles
